import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { SavedSearch } from '../saved-search';
import { BookingsSearchService } from '../service/bookings-search.service';
import { ToastMessageService } from '../toast-message.service';
import { UserService } from '../service/user.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-bookings-saved-searches',
  templateUrl: './bookings-saved-searches.component.html',
  styleUrls: ['./bookings-saved-searches.component.css']
})
export class BookingsSavedSearchesComponent implements OnInit {

  constructor(
    public bookingSearchService: BookingsSearchService,
    private toastService: ToastMessageService,
    private httpService: HttpService,
    private confirmationService: ConfirmationService,
    public userService: UserService
  ) { }

  ngOnInit(): void {
  }

  postCurrentSearchRules() {
    if (this.bookingSearchService.searchRules.length == 0) {
      this.toastService.addError("Error", "There is nothing to save");
      return;
    }
    if (this.bookingSearchService.savedSearchForm.invalid) {
      this.toastService.addError("Error", "information is missing");
      return;
    }
    let savedSearch = new SavedSearch(
      this.bookingSearchService.savedSearchForm.value.name,
      this.bookingSearchService.searchRules,
      null,
      null,
      null,
      null,
      !this.bookingSearchService.savedSearchForm.value.isPublic,
      false
    );
    this.httpService.postSavedSearch(savedSearch).subscribe(() => {
      this.toastService.addSuccess("Success", "Search saved !");
      this.bookingSearchService.savedSearchForm.reset();
      this.bookingSearchService.refreshSavedSearchList();
    }, error => {
      this.toastService.addError("Error", error.message);
    });
  }

  addToFavorite(selectedSearch: SavedSearch) {
    this.httpService.addSavedSearchToFavorite(selectedSearch.id!).subscribe(() => {
      selectedSearch.isFavorite = true;
      this.toastService.addSuccess("Success", "Search " + selectedSearch.name + " is... pinned");
      this.bookingSearchService.getFavoriteSearches();
    }, error => this.toastService.addError("Error", error.error.message));
  }

  deleteSavedSearchById(id: number) {
    this.confirmationService.confirm({
      message: "Are you sure to delete this search? (id: " + id + ")",
      accept: () => {
        this.httpService.deleteSavedSearchById(id).subscribe(() => {
          this.bookingSearchService.refreshSavedSearchList();
          this.toastService.addSuccess("Success", "Search id: " + id + "deleted.")
        }, error => {
          this.toastService.addError("Error", error.error.message);
        });
      }
    });
  }
}